// client/components/actionbarElements.ts
var ActionbarSpacer = "actionbarSpacer";
var ActionbarDropdown = class {
  constructor(icon, items, tooltip) {
    this.icon = icon;
    this.items = items;
    this.tooltip = tooltip;
  }
  get name() {
    return this.items.map((item) => item.name).join(",");
  }
};
function AsActionbarDropdown(icon, extension, tooltip) {
  return {
    ...extension,
    buttons: ({ editor, host }) => {
      const items = extension.buttons?.({ editor, host }) ?? [];
      return [new ActionbarDropdown(icon, items, tooltip)];
    }
  };
}
export {
  ActionbarDropdown,
  ActionbarSpacer,
  AsActionbarDropdown
};
